import { Controller } from "@hotwired/stimulus"

// Segmented in-page tabs: show one panel at a time, toggle the active button.
// Initial active tab is set in markup by the server (the visible panel + .active
// button, driven by @active_tab) — no connect() needed.
export default class extends Controller {
  static targets = ["tab", "panel"]

  select(event) {
    const name = event.currentTarget.dataset.tabName
    this.panelTargets.forEach((p) => p.classList.toggle("hidden", p.dataset.tabName !== name))
    this.tabTargets.forEach((t) => t.classList.toggle("active", t.dataset.tabName === name))
  }
}
